import * as z from "zod/v4";

export const resendMagicLink = {
  name: "resendMagicLink" as const,
  input: z.object({ partnerId: z.string() }),
  output: z.object({
    magicLinkSent: z.boolean(),
    magicLinkError: z.string().optional(),
  }),
};
